<template>
  <q-dialog :visible="isVisible" :title="title" width="600px" :innerScroll="false" @close="onCancel" @cancel="onCancel" @confirm="onConfirm">
    <el-table :data="tableData" border :height="'50vh'" ref="tableRef" :span-method="objectSpanMethod" v-loading="loading">
      <el-table-column label="合并统计" prop="statisticalName" align="center">
        <template slot-scope="scope">
          <el-input v-model="scope.row.statisticalName" :maxlength="10" @blur="statisticalNameBlur(scope.row.statisticalName)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="店铺简称" prop="storeCode" align="center">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.storeCode"
            size="mini"
            placeholder="请选择"
            filterable
            :ref="`mySelect${scope.$index}`"
            @visible-change="selectRefName = `mySelect${scope.$index}`"
            @change="storeChange(scope.$index)"
            :popper-append-to-body="false"
          >
            <el-option v-for="(item,index) in storeList" :key="index" :label="item.name" :value="item.code"> </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="left" width="90">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="add(scope)">新增</el-button>
          <el-button type="text" size="mini" @click="del(scope)" style="color: red" v-if="tableData.length > 1"> 删除 </el-button>
        </template>
      </el-table-column>
    </el-table>
  </q-dialog>
</template>

<script>
import moment from "moment";
import axios from "@/utils/axiosInstance";
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  name: "CRUDEdit",
  mixins: [mixin],
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    tableDataDialog: {
      type: Array,
      default: [],
    },
    reportOptions: {
      type: Array,
      default: [],
    },
    storeList: {
      type: Array,
      default: [],
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return this.rowData ? "编辑" : "新增";
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      spanIndex: 0,
      spanArr: [],
      tableData: [],
      selectRefName: ''
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      if(!this.tableData.length) {
        this.$message.error('请至少填写一个店铺')
        return
      }
      this.loading = true
      let data = this.tableData.map(v=>{
        return {
          ...v,
          statisticalNameOld: this.rowData ? this.tableDataDialog[0].statisticalName : '',
          dataId: this.rowData ? this.tableDataDialog[0].dataId : ''
        }
      })
      this.$q.preSalePlan.saveOrUpdate({data: data}).then(res=>{
        if(res.success) {
          this.$message.success(`${this.title}成功`)
          this.onCancel()
          this.$emit('success')
        }else {
          this.$message.error(res.message)
        }
      }).finally(res => {
        this.loading = false
      })
    },
    async init() {},
    add(scope) {
      this.tableData.splice(scope.$index + 1, 0, { statisticalName: scope.row.statisticalName, storeName: "" });
      this.computeSpanData(this.tableData);
    },
    del(scope) {
      this.tableData.splice(scope.$index, 1);
    },
    storeChange(index) {
      this.$nextTick(_=>{
        this.tableData[index].storeName = this.$refs[this.selectRefName].selected.label
      })
    },
    statisticalNameBlur(val) {
      this.tableData.forEach(v=> {
        v.statisticalName = val
      })
      this.computeSpanData(this.tableData)
    },
    // 遍历表格数据，计算合并行数据
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    // 计算每一行的合并行数据
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanArr.push(1);
        this.spanIndex = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[index].statisticalName === data[index - 1].statisticalName) {
          this.spanArr[this.spanIndex] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.spanIndex = index;
        }
      }
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return {
          rowspan: this.spanArr[rowIndex],
          colspan: 1,
        };
      }
    },
    handleTableScroll() {
      if(!this.selectRefName) return
      console.log(this.$refs.mySelect);
      this.$refs[this.selectRefName].blur();
    },
  },
  mounted() {
    console.log(this.authOptions);
    this.$nextTick((_) => {
      this.$refs.tableRef.bodyWrapper.addEventListener("scroll", this.handleTableScroll);
    });
    this.tableData = this.rowData ? JSON.parse(JSON.stringify(this.tableDataDialog)) : [{ statisticalName: "", storeName: "" }];
    this.computeSpanData(this.tableData);
  },
};
</script>

<style lang="stylus" scoped>
  >>>.el-input__inner, .el-input--mini .el-input__inner {
    width: 100% !important
}
</style>
